import { render } from "./ModalQuestionario.vue?vue&type=template&id=82fe554c&scoped=true"
import script from "./ModalQuestionario.vue?vue&type=script&lang=js"
export * from "./ModalQuestionario.vue?vue&type=script&lang=js"

import "./ModalQuestionario.vue?vue&type=style&index=0&id=82fe554c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fe554c"]])

export default __exports__